import { Drawer } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import * as Yup from 'yup';
import { Form, Formik, FormikProps } from "formik";
import { ServerAPI } from "../common/ServerAPI";
import toast from "react-hot-toast";
import React from "react";
import { useAppStateAPI } from "../common/AppStateAPI";
import { APIData, FormDataTypes } from "../common/DataTypes";
import { InitialData } from "./InitialData";
import FormField from "../components/form_items/FormField";
import { API, ProjectStrings, uploadImageType } from "../common/Constants";
import { getDataFromAPI } from "../common/Utilities";


const MenuEntryDialog: React.FC<{ showDialog: boolean, closeDialog: any, reloadData: any, id?: string, detailView?: boolean }> = ({ showDialog, closeDialog, reloadData, id, detailView }) => {

    const { addProcessingRequests, reduceProcessingRequests } = useAppStateAPI();
    const formikRef = useRef<FormikProps<APIData.MenuEntry>>(null);
    const [initialValue, setInitialValue] = useState<APIData.MenuEntry>(InitialData.MenuEntry);
    const [formDataSet, setFormDataSet] = useState(false);
    const [companyOptions, setCompanyOptions] = useState<FormDataTypes.SelectOption[]>([]);
    const [editMode, setEditMode] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);

    useEffect(() => {
        let params: { [k: string]: any } = {};
        params["limit"] = 10000;
        params["status"] = 1;
        getDataFromAPI(API.EndPoint.CompanyList, setCompanyOptions, addProcessingRequests, reduceProcessingRequests, params, true, 'uuid', 'company_name', 'data', 'list');
    }, []);

    useEffect(() => {
        if (id !== undefined && id !== '') {
            addProcessingRequests();
            ServerAPI.getMenu(id).then(response => {
                if (response && response.data && response.data.details) {
                    setInitialValue(response.data.details);
                    setFormDataSet(true);
                    setEditMode(true);
                }
            }).finally(() => {
                reduceProcessingRequests();
            });
        } else {
            setFormDataSet(true);
        }
    }, [id]);

    const yupSchema = Yup.object().shape({
        name: Yup.string().required(ProjectStrings.ValidationRequired),
        code: Yup.string().required(ProjectStrings.ValidationRequired),
        company_id: Yup.string().notOneOf(["0"], ProjectStrings.ValidationSelect).required(ProjectStrings.ValidationRequired),
    });

    return (
        <Drawer anchor="right" open={showDialog} onClose={closeDialog} className="drawer-min">
            {formDataSet && (
                <Formik validationSchema={yupSchema} enableReinitialize={true} validateOnChange={false} initialValues={initialValue} innerRef={formikRef} onSubmit={(values, { setSubmitting }) => {
                    setFormIsValid(true);
                    let submitValues: any = { ...values };
                    if (id != undefined && id != '') {
                        addProcessingRequests();
                        ServerAPI.updateMenu(submitValues).then(response => {
                            if (response && response['success'] && response['message']) {
                                toast.success(response['message']);
                                reloadData();
                                closeDialog();
                            } else if (response && response['message']) {
                                toast.error(response['message']);
                            } else {
                                toast.error('Unknown Error Occurred');
                            }
                        }).finally(() => {
                            setSubmitting(false);
                            reduceProcessingRequests();
                        });
                    } else {
                        addProcessingRequests();
                        ServerAPI.addMenu(submitValues).then(response => {
                            if (response && response['success'] && response['message']) {
                                toast.success(response['message']);
                                reloadData();
                                closeDialog();
                            } else if (response && response['message']) {
                                toast.error(response['message']);
                            } else {
                                toast.error('Unknown Error Occurred');
                            }
                        }).finally(() => {
                            setSubmitting(false);
                            reduceProcessingRequests();
                        });
                    }
                }} >
                    {(formikProps) => {
                        return (
                            <div className="tabdetails">
                                <h4 className="title-text text-center">{editMode ? 'Edit' : 'Add New'} Menu</h4>
                                <div className="custom-border-grey my-2"></div>
                                <p className="detailed-heading">Menu Details</p>
                                <div className="tabpage">
                                    <div className="custom-border-grey my-2"></div>
                                    <div className="tab-details-section p-0">
                                        <Form>
                                            <div className="form-field-container">
                                                <div className="row px-2 py-3">
                                                    <div className="col-lg-12 col-md-12 col-xl-12 text-field-empty-custom-user">
                                                        <FormField formik={formikProps} fieldProps={{ fieldType: "textbox", name: "name", label: "Menu Name", placeholder: "Menu Name", required: true }} />
                                                    </div>
                                                </div>
                                                <div className="row px-2 py-3">
                                                    <div className="col-lg-12 col-md-12 col-xl-12 text-field-empty-custom-user">
                                                        <FormField formik={formikProps} fieldProps={{ fieldType: "textbox", name: "code", label: "Code", placeholder: "Code", required: true }} />
                                                    </div>
                                                </div>
                                                <div className="row px-2 py-3">
                                                    <div className="col-lg-12 col-md-12 col-xl-12 text-field-empty-custom-user">
                                                        {/* <label className="label-custom-user"><p>Company</p></label> */}
                                                        <FormField formik={formikProps} fieldProps={{ fieldType: "select", label: "Company", name: "company_id", placeholder: "Company", required: true, options: companyOptions, readOnly: detailView ? true : false }} />
                                                    </div>
                                                </div>
                                                <div className="row px-2 py-3">
                                                    <div className="col-lg-12 col-md-12 col-xl-12 text-field-empty-custom-user">
                                                        <FormField formik={formikProps} fieldProps={{ fieldType: "fileupload", name: "icon", label: "Menu Icon", placeholder: "Menu Icon", required: true, accept: "image/*", imageType: uploadImageType.DEMO_VEHICLE }} />
                                                    </div>
                                                </div>
                                                <div className="row px-2 py-3">
                                                    <div className="col-lg-12 col-md-12 col-xl-12 text-field-empty-custom-user">
                                                        <FormField formik={formikProps} fieldProps={{ fieldType: "switch", label: "Status", name: "status" }} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row btn-form-submit">
                                                <button type="button" className="button1" onClick={closeDialog}>Cancel</button>
                                                <button type="button" className="button2" disabled={formikProps.isSubmitting} onClick={() => {
                                                    setFormIsValid(false);
                                                    formikProps.submitForm();
                                                    setTimeout(() => {
                                                        //SetTimeout will always return old value for a state. So we are fetching the new value using the setter function.
                                                        setFormIsValid(previousIsValid => {
                                                            if (!previousIsValid) {
                                                                toast.error("Please ensure all fields are Filled and Valid!");
                                                            }
                                                            return previousIsValid; // Return the same state to avoid changing it
                                                        });
                                                    }, 500);
                                                }}>Submit</button>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        )
                    }}
                </Formik>
            )
            }
        </Drawer>
    )
}

export default MenuEntryDialog;